// @flow
import CONST from 'app/common/lib/Const';
import trackRegisterAction from 'app/common/lib/util/trackRegisterAction';

const GPLUS_SCOPE_PROFILE_EMAIL = 'profile email';

const auth2Params = {
  scope: GPLUS_SCOPE_PROFILE_EMAIL,
  client_id: CONST.GEN.templateConst.settings.GPLUS_CLIENT_ID,
  app_package_name: CONST.GEN.templateConst.settings.GPLUS_APP_PACKAGE_NAME,
  access_type: 'offline',
  cookie_policy: 'single_host_origin',
};

const resolvePromise = (resolve: Function) => {
  trackRegisterAction('unauth_web.gapi_auth2_load.success');
  return resolve();
};

const track = (action: string) => {
  trackRegisterAction(`unauth_web.init_google.sdk.${action}`);
};

const initGoogleAuth2SDK = () =>
  new Promise<*>((resolve, reject) => {
    track('start');
    if (window.gapi.auth2) {
      track('exists');
      window.gapi.auth2.init(auth2Params).then(() => resolvePromise(resolve));
    } else {
      track('load');
      window.gapi.load('auth2', {
        callback: () => {
          track('load_success');
          window.gapi.auth2.init(auth2Params).then(() => resolvePromise(resolve));
        },
        onerror: () => {
          track('load_error');
          reject();
        },
        timeout: 15000, // milliseconds
        ontimeout: () => {
          track('load_timeout');
          reject();
        },
      });
    }
  });

export default initGoogleAuth2SDK;
